import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { BlockProps } from "../types";
import { useBlock } from ".";

export interface UseContentBlockArgs extends BlockProps {}

export const useContentBlock = (args: UseContentBlockArgs) => {
  const { t } = useTranslation("contacts");

  const block = useBlock({ ...args, type: "content.content", select: (enduser) => enduser });

  const [showShareForm, setShowShareForm] = useState(false);

  const openShareForm = useCallback(() => setShowShareForm(true), []);
  const closeShareForm = useCallback(() => setShowShareForm(false), []);

  const enduser = block.enduserQuery.data;

  return {
    ...block,
    t,
    enduser,
    showShareForm,
    openShareForm,
    closeShareForm,
  };
};
